{
  "advancededitor": {
    "Add entry": "Ajouter une entrée",
    "Duplicate": "Dupliquer",
    "Image attached": "Image ci-jointe",
    "Inherit from wheel": "Hériter de la roue",
    "Not shown on the wheel": "Non indiqué sur le volant",
    "Popup message": "Message contextuel",
    "Shown on the wheel": "Montré sur la roue",
    "Weight": "Poids"
  },
  "app": {
    "Ads": "Les publicités",
    "Click here to report an inappropriate ad": "Cliquez ici pour signaler une annonce inappropriée.",
    "Click the Language menu": "Cliquez sur le menu en haut à droite pour passer en français",
    "Close ad": "Fermer l'annonce",
    "Common questions about using the random name picker wheel": "Questions courantes sur l'utilisation de la roue de sélection de noms aléatoire",
    "Copy this wheel": "Copie cette roue",
    "Create your own": "Crée le tien",
    "Error": "Erreur",
    "Free and easy to use": "Gratuit et facile d'utilisation. Utilisé par les enseignants et pour les tombolas. Entrez des noms et faites tourner la roue pour choisir un gagnant au hasard. Personnalisez l'apparence, enregistrez et partagez les roues.",
    "Frequently Asked Questions": "Foire aux questions",
    "It looks like you are using Internet Explorer": "Il semble que vous utilisez Internet Explorer. Ce navigateur cessera bientôt de recevoir les mises à jour de sécurité de Microsoft. Cela vous expose, vous et nous, à de grands risques.\nBientôt, vous ne pourrez plus utiliser ce site Web avec Internet Explorer. Veuillez télécharger un autre navigateur en faisant une recherche en ligne pour \"télécharger le navigateur Web\". N'importe quel navigateur moderne fera l'affaire, par exemple Chrome, Firefox ou Edge.",
    "Loaded default names and options": "Noms et options par défaut chargés",
    "Random name picker": "Sélecteur de nom aléatoire",
    "Removed": "{name} retiré",
    "Removing winner in": "Supprimer le gagnant dans {seconds}  secondes",
    "Report bad ad": "Signaler une mauvaise annonce",
    "Warning": "Attention",
    "We try to display only legitimate and honest ads": "Nous essayons de n'afficher que des publicités légitimes et honnêtes.",
    "authError": "Ça n'a pas marché. Veuillez réessayer et vous serez invité à vous connecter. Si cela ne fonctionne toujours pas, essayez ces choses: actualisez la page avec Ctrl + Maj + R (Windows, Linux, Chromebook) ou Commande + Maj + R (Mac), désactivez votre bloqueur de publicités, désactivez votre logiciel antivirus. \n\n({error})"
  },
  "faq": {
    "How do I use this app": "Comment utiliser cette application",
    "This app lets you spin a wheel": "Cette application vous permet de faire tourner une roue",
    "Can I save my wheel": "Puis-je sauvegarder ma roue",
    "Yes, if you create an account": "Oui, si vous créez un compte",
    "Is this app free": "Cette application est-elle gratuite",
    "Yes, this app is completely free": "Oui, cette application est entièrement gratuite"
  },
  "appInfo": {
    "Terms of service": "Conditions d'utilisation",
    "Version": "Version"
  },
  "common": {
    "Cancel": "Annuler",
    "Close": "Fermer",
    "Continue": "Continuer",
    "Customize": "Personnaliser",
    "Delete": "Supprimer",
    "Edit description": "Éditer la description",
    "Edit title": "Editer le titre",
    "Edit title and description": "Modifier le titre et la description",
    "If you dont see a Google login button below": "Si vous ne voyez pas de bouton de connexion Google ci-dessous, c'est probablement parce que vous utilisez un bloqueur de publicités qui pense à tort que le bouton est une publicité.",
    "Link Google Account": "Lier le compte Google",
    "Link Google Sheet": "Lier la feuille Google",
    "Link Google Spreadsheet": "Associer une feuille de calcul Google",
    "My account": "Mon compte",
    "OK": "OK",
    "Open": "Ouvrir",
    "Privacy policy": "Confidentialité",
    "Report offensive content": "Signaler un contenu offensant",
    "Save": "Enregistrer",
    "Sign in with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Create account": "Créer un compte",
    "or": "ou",
    "Email": "E-mail",
    "Password": "Mot de passe",
    "Display name": "Nom d’affichage",
    "Display name is required": "Le nom d’affichage est requis",
    "Sign in instead": "Se connecter à la place",
    "Use this in the classroom": "Utilisez-le en classe",
    "We have a winner!": "Nous avons un gagnant!",
    "Wheel description": "Description de la roue",
    "Wheel title": "Titre de la roue",
    "Max": "Max",
    "Move down": "Déplacer vers le bas",
    "Move up": "Déplacer vers le haut"
  },
  "nameTabs": {
    "Clear the list": "Effacer la liste",
    "Entries": "Les entrées",
    "Hide": "Cacher",
    "Results": "Résultats"
  },
  "opendialog": {
    "Are you sure": "Voulez-vous vraiment supprimer \"{wheelTitle}\"? Cette action ne peut pas être annulée.",
    "Delete wheel": "Supprimer la roue",
    "No wheels found": "Aucune roue trouvée dans votre compte. Essayez d'enregistrer une roue!",
    "Open wheel": "Ouvre mes roues sauvées",
    "To open wheels": "Pour ouvrir les roues, vous devez vous connecter à un compte.\nVeuillez choisir votre méthode de connexion ci-dessous."
  },
  "optionsdialog": {
    "After spin": "Après l'essorage",
    "All names in the text-box": "Tous les noms dans la zone de texte ont les mêmes chances de gagner, quelle que soit cette valeur.",
    "Animate winning entry": "Animer la participation gagnante",
    "Appearance": "Apparence",
    "Apply a theme": "Appliquer un thème",
    "Auto-remove winner after 5 seconds": "Supprimer automatiquement le gagnant au bout de 5 secondes",
    "Background color": "Couleur d'arrière-plan de la page",
    "Center text": "Texte au centre",
    "Colors": "Couleurs",
    "Colors tooltip": "Cliquez sur les échantillons de couleurs pour les modifier",
    "Contours": "Contours",
    "Custom": "Image personnalisée",
    "Customize colors": "Personnalisez les couleurs",
    "Disabled because the entries": "Désactivé car les entrées ont des poids inégaux",
    "Display Hide button": "Afficher le bouton \"Masquer\"",
    "Display Remove button": "Afficher le bouton \"Supprimer\"",
    "Display duplicates": "Afficher les doublons",
    "Display every entry": "Afficher chaque entrée dans la zone de texte comme une entrée sur la roue, même les doublons",
    "Display popup with message:": "Afficher une fenêtre contextuelle avec un message:",
    "During spin": "Pendant l'essorage",
    "From Gallery": "Une image de la galerie",
    "Image": "Image",
    "Image in the center of the wheel": "Image au centre de la roue",
    "Image size": "Taille de l'image",
    "Launch confetti": "Lancer des confettis",
    "Max names on wheel": "Nombre maximum de noms sur la roue",
    "No": "Non",
    "One color": "Une couleur par section",
    "Options": "Options",
    "Pick category": "Choisissez une catégorie",
    "Pick theme": "Choisir un thème",
    "Play click sound when the winner is removed": "Jouer un son de clic lorsque le gagnant est retiré",
    "Remove image": "Supprimer l'image",
    "Select a gallery picture": "Sélectionnez une photo de la galerie",
    "Show title": "Montrer le titre",
    "Sound": "Du son",
    "Spin slowly": "Faites tourner lentement",
    "Spin time (seconds)": "Temps d'essorage (secondes)",
    "Text": "Texte",
    "Upload image": "Téléchargez une image",
    "Volume": "Volume",
    "Wheel background image": "Image d'arrière-plan de la roue",
    "Yes": "Oui",
    "Your image has been uploaded": "Votre image '{fileName}' a été téléchargée avec succès. Souhaitez-vous utiliser les couleurs proéminentes de cette image pour les secteurs de votre roue?",
    "Advanced mode is enabled": "Le mode avancé est activé",
    "Sounds": "Sons",
    "Behavior": "Comportement",
    "Effects": "Effets",
    "Color": "Couleur"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "Voulez-vous vraiment supprimer votre compte et toutes vos roues enregistrées? Cette action ne peut pas être annulée.",
    "Delete account": "Supprimer le compte",
    "Delete my account": "Supprimer mon compte",
    "Export my data": "Exporter mes données",
    "Sign out": "Déconnexion",
    "Signed out": "Déconnecté",
    "Signed in as": "Connecté en tant que {name}",
    "Anonymous user": "Utilisateur anonyme",
    "Welcome new user": "Bienvenue sur Spin the Names ! Votre compte a été créé.",
    "Signed in success": "Connexion réussie !",
    "Your account and your saved wheels have been deleted": "Votre compte et vos roues enregistrées ont été supprimés"
  },
  "savedialog": {
    "Save as": "Enregistrer sous",
    "Save wheel": "Enregistrer une roue",
    "Select a wheel": "Sélectionnez une roue",
    "Sorry, too many images": "Désolé, cette roue contient trop d'images pour être enregistrées dans la base de données. Réduisez le nombre d'images et réessayez d'enregistrer.",
    "To save wheels": "Pour enregistrer les roues, vous devez vous connecter à un compte.\nVeuillez choisir votre méthode de connexion ci-dessous.",
    "Wheel saved successfully": "La roue \"{wheelTitle}\" a été enregistrée avec succès",
    "You will always be able to access": "Vous pourrez toujours accéder à vos roues enregistrées tant que vous ouvrez ou enregistrez une roue au moins une fois tous les 12 mois.",
    "Your existing wheels": "Vos roues existantes"
  },
  "sharedialog": {
    "Copy link": "Copier le lien",
    "Created": "Créé",
    "If you continue": "Si vous continuez, vous allez créer un lien public vers votre roue actuelle, y compris ses noms, couleurs et paramètres.",
    "Last viewed": "Dernière consultation",
    "Link": "Lien",
    "Link copied to the clipboard": "Lien copié dans le presse-papiers",
    "Link to this wheel": "Lien vers cette roue avec les noms, couleurs et paramètres actuels:",
    "My shared wheels": "Mes roues partagées",
    "No wheels found": "Aucune roue partagée trouvée dans votre compte. Essayez de partager une roue !",
    "See my shared wheels": "Voir mes roues partagées",
    "Shareable link": "Lien partageable",
    "Show title to people": "Montrez le titre aux personnes qui utilisent votre lien partagé",
    "Sorry, too many images": "Désolé, cette roue contient trop d'images pour être partagées. Réduisez le nombre d'images et réessayez d'enregistrer.",
    "They should be able to spin the wheel and": "Ils devraient pouvoir faire tourner la roue et en faire une copie",
    "They should only be able to spin the wheel": "Ils ne devraient pouvoir faire tourner la roue",
    "This link will work for anyone": "Ce lien fonctionnera pour tout le monde et vous pouvez le partager par e-mail, site Web, réseaux sociaux, etc. Les liens inutilisés seront supprimés après 365 jours.",
    "Visits": "Visites",
    "We want this website to be safe place for everyone": "Nous voulons que ce site Web soit un endroit sûr pour tout le monde. Les roues qui ne sont pas adaptées aux familles et qui violent les conditions d'utilisation seront supprimées.",
    "What should a person be able to do": "Que devrait faire une personne lorsqu'elle utilise votre lien partagé?"
  },
  "sheetdialog": {
    "Column": "Colonne",
    "First row": "Première rangée",
    "Is a header and should not be imported": "Est un en-tête et ne doit pas être importé",
    "Link sheet": "Lier la feuille de calcul",
    "Select a column": "Sélectionnez une colonne",
    "Select a tab": "Sélectionnez un onglet",
    "Selected spreadsheet": "Feuille de calcul sélectionnée",
    "Tab": "Onglet",
    "To import sheets": "Pour importer des feuilles, vous devez vous connecter à votre compte Google. Pourquoi? Google a besoin de savoir qui vous êtes, afin de vous permettre de choisir l'une de vos feuilles de calcul.",
    "When you link a spreadsheet": "Lorsque vous liez une feuille de calcul, la roue contiendra les mêmes entrées que la feuille de calcul. Si des lignes sont ajoutées ou supprimées dans la feuille de calcul, les entrées sont automatiquement ajoutées et supprimées de la roue. La connexion se fermera après une heure.",
    "added": "{entry} ajouté",
    "entries added": "{count} entrées ajoutées"
  },
  "sounds": {
    "Alarm clock": "Réveil",
    "Angel choir": "choeur des anges",
    "Announcement bell": "Cloche d'annonce",
    "Applause": "Vifs applaudissements",
    "Basketball buzzer": "Buzzer de basket-ball",
    "Bell ringing": "Sonnerie de cloche",
    "Bird chirps": "Gazouillis des oiseaux",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Cri de carnaval",
    "Cartoon whistle": "Sifflet de dessin animé",
    "Cat meow": "Chat miaou",
    "Childrens hooray": "Hourra pour les enfants",
    "Cinematic drum impact": "Impact de tambour cinématographique",
    "Cinematic music": "Musique de cinéma",
    "Correct answer ding": "Bonne réponse ding",
    "Crash": "crash",
    "Cymbals": "Cymbales",
    "Dog bark": "Aboiement",
    "Drum roll": "Roulement de tambour",
    "Easy listening": "Ecoute facile",
    "Evil laugh": "Rire diabolique",
    "Fanfare": "Fanfare",
    "Fireworks": "Feux d'artifice",
    "Game win ding": "Jeu gagnant",
    "Ghost": "Fantôme",
    "Hooray": "Hourra",
    "Horror scream": "cri d'horreur",
    "Horse": "Cheval",
    "Joke punchline": "Blague punchline",
    "Lion roar": "Lion rugissant",
    "Lost game": "Jeu perdu",
    "Microwave ding": "Micro-ondes",
    "Military trumpet": "Trompette militaire",
    "Mystery bell": "Cloche mystère",
    "No sound": "Pas de son",
    "Notification bell": "Cloche de notification",
    "Old phone ringing": "Vieux téléphone qui sonne",
    "Pan flute": "Flûte de pan",
    "Pop music": "Musique pop",
    "Random 8-Bit": "8 bits aléatoires",
    "Random ballroom dancing": "Danse de salon au hasard",
    "Random cinematic music": "Musique de cinéma aléatoire",
    "Random dance & techno": "Danse aléatoire & techno",
    "Random disco": "Discothèque aléatoire",
    "Random easy listening": "Écoute facile aléatoire",
    "Random electronica": "Électronique aléatoire",
    "Random folk music": "Musique folklorique aléatoire",
    "Random funk": "Funk aléatoire",
    "Random hip hop": "Hip-hop au hasard",
    "Random music": "Musique aléatoire",
    "Random polka": "Polka aléatoire",
    "Random pop music": "Musique pop aléatoire",
    "Random reggae & reggaeton": "Reggae et reggaeton aléatoires",
    "Random retro-rock": "Rétro-rock aléatoire",
    "Random rock music": "Musique rock aléatoire",
    "Random rockabilly": "Rockabilly aléatoire",
    "Random silent film score": "Musique de film muet aléatoire",
    "Random winter holidays": "Musique de vacances d'hiver aléatoire",
    "Random world music": "Musiques du monde au hasard",
    "Read out the winning name": "Lisez le nom gagnant",
    "Read out the winning name (option 1)": "Lire le nom gagnant (option 1)",
    "Read out the winning name (option 2)": "Lire le nom gagnant (option 2)",
    "Referee whistle": "Sifflet d'arbitre",
    "Rock music": "Musique rock",
    "Sad trombone": "Trombone triste",
    "Silent film score": "Musique de film muet",
    "Sound effects": "Effets sonores",
    "Subdued applause": "Applaudissements modérés",
    "Swoosh ding": "Swoosh ding",
    "Synth bell": "Cloche de synthé",
    "Taiko drum": "Taiko tambour",
    "Thunder": "Tonnerre",
    "Ticking sound": "Son de tic-tac",
    "Twinkling star": "Étoile scintillante",
    "Water splash": "Éclaboussure d'eau",
    "Winter holidays": "Musique de vacances d'hiver",
    "Wolf howl": "hurlement de loup",
    "World music": "Musique du monde",
    "Xylophone ascending": "Xylophone ascendant"
  },
  "spinningwheel": {
    "Click to spin": "Cliquez pour tourner",
    "Tap to spin": "Appuyez pour tourner",
    "or press ctrl+enter": "ou appuyez sur ctrl+entrée"
  },
  "textboxbuttons": {
    "Add image": "Ajouter une image",
    "Advanced": "Avancée",
    "Revert from advanced": "Revenir",
    "Reverting will reset": "Si vous revenez du mode avancé, vous risquez de perdre certaines couleurs. Êtes-vous sur de vouloir continuer?",
    "Shuffle": "Mélanger",
    "Sort": "Trier"
  },
  "toolbar": {
    "Add your language": "Ajoutez votre langue",
    "Dark mode": "Mode sombre",
    "Exit fullscreen": "Quitter le mode plein écran",
    "FAQ": "FAQ",
    "Feedback": "Rétroaction",
    "Fullscreen": "Plein écran",
    "Language": "Langue",
    "More": "Plus",
    "New": "Nouveau",
    "Offline mode": "Mode hors-ligne",
    "Please enter your email address": "Veuillez saisir votre adresse e-mail pour continuer",
    "Send debug data": "Envoyer des données de débogage",
    "Share": "Partager",
    "System theme": "Thème du système",
    "Theme settings": "Paramètres de thème",
    "Light theme": "Thème clair",
    "Dark theme": "Thème sombre",
    "Light": "Clair",
    "Dark": "Sombre",
    "Currently using": "Actuellement utilisé",
    "Theme": "Thème",
    "Unlink Google Spreadsheet": "Dissocier la feuille de calcul Google",
    "User reviews and tutorials": "Avis d'utilisateurs et tutoriels",
    "Your session is now being recorded": "Votre session est en cours d'enregistrement. Vous pouvez arrêter l'enregistrement en fermant la fenêtre de votre navigateur."
  },
  "winnerdialog": {
    "Hide": "Cacher",
    "Remove": "Supprimer",
    "Remove all instances": "Supprimer toutes les instances"
  },
  "banner": {
    "setupMessage": "Bonjour ! Nous sommes encore en train de tout mettre en place. Certaines fonctionnalités peuvent être limitées ou temporairement indisponibles. Merci pour votre patience !",
    "dismissLabel": "Fermer l'annonce"
  },
  "accountdialog": {
    "Sign in intro": "Connectez-vous pour sauvegarder, partager et gérer vos roues.",
    "Preparing sign-in": "Préparation des options de connexion…",
    "Troubleshooting title": "Dépannage de la connexion",
    "Login failed": "Échec de la connexion. Veuillez réessayer.",
    "Email verified": "E-mail vérifié",
    "Email not verified": "E-mail non vérifié",
    "Resend verification email": "Renvoyer l'e-mail de vérification",
    "Verification email sent": "E-mail de vérification envoyé. Vérifiez votre boîte de réception et le dossier spam.",
    "Verification email failed": "Échec de l'envoi de l'e-mail de vérification. Veuillez réessayer plus tard."
  }
}
